import React from 'react';
import { Row, Col } from 'antd';
import KPICard from './KPICard';

export interface KpiItem {
  title: string;
  value: number;
  previousValue?: number;
  prefix: React.ReactNode;
  isCurrency?: boolean;
  sparklineData?: number[];
}

interface KpiGridProps {
  items: KpiItem[];
  loading?: boolean;
}

export const KpiGrid: React.FC<KpiGridProps> = ({ items, loading = false }) => (
  <section className="dashboard-section dashboard-kpi-section">
    <Row className="dashboard-kpi-grid" gutter={[24, 24]}>
      {items.map(item => (
        <Col
          xs={24}
          sm={12}
          lg={6}
          key={item.title}
          className="dashboard-kpi-col"
        >
          <KPICard
            title={item.title}
            value={item.value}
            previousValue={item.previousValue}
            prefix={item.prefix}
            isCurrency={item.isCurrency}
            variant="admin"
            loading={loading}
            sparklineData={item.sparklineData}
          />
        </Col>
      ))}
    </Row>
  </section>
);
